"use client";

import Link from "next/link";
import { useActionState } from "react";
import { signup } from "@/app/actions/auth";
import { Button, ErrorBanner, Field, TagCard, Wordmark } from "@/components/ui";

export default function SignupPage() {
  const [state, formAction, pending] = useActionState(signup, undefined);

  return (
    <main className="flex flex-1 flex-col items-center justify-center gap-8 px-6 py-24">
      <Wordmark />
      <div className="w-full max-w-sm">
        <TagCard>
          <h1 className="mb-6 font-mono text-lg font-semibold text-ink">Create account</h1>
          <form action={formAction} className="flex flex-col gap-4">
            <Field label="Email" name="email" type="email" required autoComplete="email" />
            <Field
              label="Password"
              name="password"
              type="password"
              required
              autoComplete="new-password"
              minLength={8}
            />
            {state?.error && <ErrorBanner>{state.error}</ErrorBanner>}
            <Button type="submit" disabled={pending} className="mt-2">
              {pending ? "Creating account…" : "Sign up"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-ink-muted">
            Already have an account?{" "}
            <Link href="/login" className="font-semibold text-moss hover:underline">
              Log in
            </Link>
          </p>
        </TagCard>
      </div>
    </main>
  );
}
